import * as network from './player'
import * as R2M from './R2MAccess'
import * as marietta from '../../../marietta';
import { communication, newtworkStatus } from './communication'

export type result = {
    "host": string, //※wss接続先ホスト。「waiting」=0かつ「ready」=trueの場合「host」にwss接続先ホスト情報が入った状態でレスポンスされる。
    "waiting": number, //※接続待ちユーザ クライアントの待ち人数表示に使用。
    "ready": boolean //※接続できるかの有無。true=接続可、false＝接続不可
}

export class R2MCommunication extends communication {

    private _userID: string;
    public get userID(): string {
        return this._userID;
    }

    private server: R2M.R2MAccess;


    public resultObject: result;

    constructor() {
        super();
        this.addReceiver(new R2MStatus(this));
    }

    private setStatus(num: network.modetype) {
        this.status = num;
        this.networkStatus(num);
    }

    public resetUser() {
        if (this._userID) {
            this._userID = undefined;
        }
    }

    public UserRegistration() {
        console.log("R2MServer User Registration");
        if (this._userID) {
            console.log(`R2MServer UserID: ${this._userID}`);
            return Promise.resolve();
        }

        this.status = -100;     //待機
        this.server = new R2M.R2MAccess();
        return this.server.post().then((object) => {
            /*
                {
                    "playerToken": "31F49974-34C1-11ED-B519-1E6F7F377B23"
                }
                202の場合、playerTokenにuuidが、404の場合、空文字列が返る
            */
            console.log('object : ', object);
            if (object == null) {
                return Promise.reject(new Error("JSONの取得に失敗しました."));
            }
            if (object.playerToken.length == 0) {
                marietta.webcad.WebCADGlobal.showAlert(object.message);
                this.setStatus(network.statustype.unknown);
                return Promise.resolve();
            }

            this._userID = object.playerToken;
            this.setStatus(network.statustype.registered);      // ユーザー登録が完了

            console.log(`R2MServer UserID: ${this._userID}`);

            return Promise.resolve();
        }).catch((str) => {
            console.log('str (registUser): ', str);
            marietta.webcad.WebCADGlobal.showAlert(`サーバーへのアクセスに失敗しました。<br>${str}`);
            this.setStatus(network.statustype.unknown);
            Promise.reject(str);
        });
    }

    public serverAccess(): Promise<result> {
        console.log("R2MServer Access -\n");

        return this.server.get(this._userID).then((object) => {
            console.log('object : ', object);
            if (object == null) {
                throw new Error("JSONの取得に失敗しました.");
            }
            this.resultObject = object;

            if (!object.ready) {
                console.log('ready is false : ', object);
                this.setStatus(network.statustype.wait);
                return Promise.resolve(object);
            }

            this.resetUser();

            this.streamingPlayer = new network.player(this.resultObject.host);

            // this.streamingPlayer.addReceiver(new R2MStatus(this));

            this.receivers.forEach((receiver) =>this.streamingPlayer?.addReceiver(receiver));

            this.streamingPlayer.connect();
            return Promise.resolve(object);
        }).catch((str) => {
            console.log('str (serverAccess): ', str);
            marietta.webcad.WebCADGlobal.showAlert(`サーバーへのアクセスに失敗しました。<br>${str}`);
            this.setStatus(network.statustype.unknown);
            throw str;
        });
    }

    public reset() {
        // this.status = network.statustype.unknown;
        this.setStatus(network.statustype.unknown);
        this._userID = '';
    }
}

export class R2MStatus implements network.playerStatus
 {
    constructor(private communication: communication) {}

    public onChange(status) {

        if (status === network.statustype.connect) {
            console.log('R2M - Connect WebRTC DataChannel.');
        }
        if (status == network.statustype.disconnect) {
            console.log('R2M - Dicconnect.');
            // 接続解除時にUserIDをリセット
            (this.communication as R2MCommunication).resetUser();
        }
        if (status == network.statustype.registered) {
            console.log('R2M - registered.');
        }
        if (status == network.statustype.wait) {
            console.log('R2M - wait.');
        }if (status == network.statustype.unknown) {
            console.log('R2M - unknown.');
        }

        this.communication.status = status;
    }
 }
